module.exports = __webpack_public_path__ + "static/packaging-d0abb9ca6dd49671db958c1123be90d8.svg";